import React, { useState, useEffect } from "react";
import "./store.css";
import { Table, Typography, Spin, Button, Result } from "antd";
import { Link } from "react-router-dom";
import { getstoreList } from "../../services/store.service";
import { validationErrors } from "../../utils/Helpers";
const { Text, Title } = Typography;
const Batch = () => {
  const pagename = "Store";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  useEffect(() => {
    if (postData) {
      setErrMsg(null);
    }
  }, [postData]);
  useEffect(() => {
    if (errMsg) {
      setPostData(null);
    }
  }, [errMsg]);
  // const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      const resp = await getstoreList();
      // console.log("postLists", resp);
      setPostData(resp.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const postColumns = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Store Id",
      dataIndex: "storeId",
      key: "storeId",
    },
    {
      title: "Zone Id",
      dataIndex: "zoneId",
      key: "zoneId",
    },
    {
      title: "Action",
      render: (proId) => {
        return (
          <div>
            <Link
              proId={proId["_id"]}
              to={`/batch/batchedit/${proId["_id"]}`}
              activeClassName="current"
            >
              Edit {pagename}
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <div className="page-content">
      {loading && (
        <div className="pageloader">
          <Spin />
        </div>
      )}
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename}s Management</Title>
        </div>
        <div className="pch-content">
          <Button>
            <a href="/batch/batchcreate">{pagename} Add</a>
          </Button>
        </div>
      </div>
      {/* {postData && <Table dataSource={postData} columns={postColumns} />} */}
      {errMsg && (
        <Result
          status="warning"
          title="There are some problems with your operation."
        />
      )}
    </div>
  );
};
export default Batch;
